import script from "./InfoArea.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoArea.vue?vue&type=script&setup=true&lang=js"

import "./InfoArea.vue?vue&type=style&index=0&id=1cc6b33c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc6b33c"]])

export default __exports__